import { useQuery } from '@tanstack/react-query'
import { baseURL, headers } from '@/v2/constants/requests'

export const usePayments = ({ invoiceId }) => {
  const {
    data: payments,
    isLoading: isPaymentsLoading,
    error: isPaymentsError,
  } = useQuery({
    queryKey: ['payments', invoiceId],
    queryFn: () =>
      fetch(`${baseURL}/v2/rest/billing/invoices/${invoiceId}/payments`, {
        headers,
      }).then(res => res.json()),
    enabled: !!invoiceId,
  })

  return {
    payments: payments || [],
    isPaymentsLoading,
    isPaymentsError,
  }
}
